import { ILocality } from "../model/locality.model";

export const getProvincesNotDuplicated = (localities: ILocality[]): any[] => {
  let cleanLocalities: ILocality[] = [];
  if (localities) {
    localities.forEach((el: ILocality) => {
      if (
        !cleanLocalities.some((added) => added.province?.id === el.province?.id)
      ) {
        cleanLocalities = [...cleanLocalities, el];
      }
    });
  }

  return cleanLocalities;
};
